import { render } from "./events.vue?vue&type=template&id=13183552&lang=pug"
import script from "./events.vue?vue&type=script&lang=js"
export * from "./events.vue?vue&type=script&lang=js"

import exportComponent from "/Users/json/Code/chekt/app/fty/hosting/console/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__